import { Component } from '@angular/core';
import { WindowService } from '@cigna/core/window';

@Component({
  selector: 'cigna-resources-app-footer',
  templateUrl: './resources-app-footer.component.html',
  styleUrls: ['./resources-app-footer.component.scss'],
})
export class ResourcesAppFooterComponent {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  secure: boolean =
    this.window.location.pathname.startsWith('/assets/chcp/medical') ||
    this.window.location.pathname.startsWith('/assets/chcp/dental');

  isMedical: boolean = this.window.location.pathname.startsWith(
    '/assets/chcp/medical',
  );

  constructor(private window: WindowService) {}
}
